// components/Price.tsx

import { useCurrency } from "@/packages/context/CurrencyContext";
import CurrencySymbol from "./CurrencySymbol";
import { Inter } from "next/font/google";

const inter = Inter({
  subsets: ["latin"],
  weight: ["400", "500", "600"],
});

interface PriceProps {
  amount: number;
  className?: string;
  showDecimals?: boolean;
  symbolClassName?: string;
}

const Price: React.FC<PriceProps> = ({
  amount,
  className = "",
  showDecimals = true,
  symbolClassName = "",
}) => {
  const { symbol, exchangeRate, code } = useCurrency();

  const convertedAmount = amount * exchangeRate;

  const formattedAmount = showDecimals
    ? convertedAmount.toFixed(2)
    : Math.round(convertedAmount).toString();

  const displayPrice = `${formattedAmount}`;
  const displayCode = (code || "USD").toUpperCase();

  return (
    <span className={`${inter.className} ${className || "font-medium text-sm"}`}>
      <CurrencySymbol symbol={symbol} className={symbolClassName} />
      {displayPrice} {displayCode}
    </span>
  );
};

export default Price;
